export const SEVERITY_COLORS: Record<string, string> = {
  disaster: 'red',
  high: 'orange',
  warning: 'yellow',
  average: 'blue',
  information: 'gray',
}

/** Lower number = higher priority (sorts first) */
export const SEVERITY_ORDER: Record<string, number> = {
  disaster: 0,
  high: 1,
  average: 2,
  warning: 3,
  information: 4,
}
